import { Provider } from 'react-redux';
import store from '../../../store';
import NotificationsTrigger from './';

export default function NotificationsTriggerWithProvider(props) {
    return (
        <Provider store={store}>
            <NotificationsTrigger {...props} />
        </Provider>
    );
}
